function Navigation({ pathname, navigate }) {
  const handleClick = (event, to) => {
    event.preventDefault();
    navigate(to);
  };

  return (
    <nav className="navigation" aria-label="Main navigation">
      <a
        className={pathname === '/' ? 'active' : ''}
        href="/"
        onClick={(event) => handleClick(event, '/')}
      >
        Gallery
      </a>
      <a
        className={pathname === '/map' ? 'active' : ''}
        href="/map"
        onClick={(event) => handleClick(event, '/map')}
      >
        Map
      </a>
    </nav>
  );
}

export default Navigation;
